// El chip de las celdas de cobranza (`.chip-*` del mockup). Reusa el `Chip` compartido; el tono
// `primary` de «Mañana» no está en su paleta y se pinta con clases encima.
import type { ReactNode } from 'react';
import { Chip, type ChipTone } from '@/shared/patterns/FileDrawer';
import type { CobranzaTone } from '../logic';

const PRIMARY_CLASS = 'bg-primary/15 text-primary';

const BASE_TONE: Record<CobranzaTone, ChipTone> = {
    success: 'success',
    danger: 'danger',
    warning: 'warning',
    info: 'info',
    muted: 'muted',
    primary: 'muted',
};

export function ToneChip({ tone, children }: { tone: CobranzaTone; children: ReactNode }) {
    return (
        <Chip tone={BASE_TONE[tone]} className={tone === 'primary' ? PRIMARY_CLASS : undefined}>
            {children}
        </Chip>
    );
}
